<template>
  <div class="modal-shoes-overlay" @click.self="closePopin">
    <div class="modal-shoes row">
      <div class="modal-shoes__close" @click="closePopin">
        <img src="@/assets/images/delete.svg" />
      </div>
      <Carrousel
        class="modal-shoes__images col-xs-12"
        theId="carrousel-modal"
        v-if="data.images.length > 1"
        :images="data.images"
      />
      <div v-else class="modal-shoes__images --noslider col-xs-12">
        <img :src="data.images[0]" />
      </div>

      <div class="modal-shoes__content">
        <div class="modal-shoes__intro col-xs-12">
          <h2 class="modal-shoes__intro__title">{{ data.name }}</h2>
          <div class="modal-shoes__intro__subtitle">{{ data.color }}</div>
          <!-- <div class="modal-shoes__intro__size">
            Taille <span>{{ user.size }} EU</span>
          </div>-->
        </div>
        <div class="modal-shoes__infos row col-xs-12">
          <div class="modal-shoes__infos__item col-xs-4">
            <div>État</div>
            <div>{{ data.state }}</div>
          </div>
          <div class="modal-shoes__infos__item col-xs-4">
            <div>Sortie le</div>
            <div>{{ data.date }}</div>
          </div>
          <div class="modal-shoes__infos__item col-xs-4">
            <div>Valeur</div>
            <div>
              ~
              <span v-html="formatPrice(data.price)" />
            </div>
          </div>
        </div>
        <div class="modal-shoes__desc">{{ data.desc }}</div>
      </div>
      <Button class="modal-shoes__btn" @click.native="confirm" primary>
        Je veux cette paire !
      </Button>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@/plugins/helpers";
import Carrousel from "@/components/Common/Carrousel";
import Button from "@/components/Common/Button";
import { mapState, mapMutations } from "vuex";
export default {
  name: "ShoesModal",
  components: {
    Button,
    Carrousel
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    ...mapMutations({
      updateModalIsOpen: "updateModalIsOpen",
      updateBodyNoScroll: "updateBodyNoScroll",
      updateUserShoe: "updateUserShoe"
    }),
    formatPrice(cents) {
      return formatPrice(cents);
    },
    confirm() {
      this.updateUserShoe(this.data.id);
      this.closePopin();
      this.$router.push("/panier");
    },
    closePopin() {
      this.updateBodyNoScroll(false);
      this.updateModalIsOpen(false);
    }
  },
  created() {
    document.addEventListener(
      "backbutton",
      this.updateModalIsOpen(false),
      false
    );
  },
  beforeDestroy() {
    document.removeEventListener("backbutton", this.updateModalIsOpen);
    this.closePopin();
  }
};
</script>

<style lang="scss">
.modal-shoes {
  &-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    z-index: 50;
    @media #{$md-and-up} {
      cursor: pointer;
      overflow: auto;
      align-items: flex-start;
    }
  }
  position: relative;
  justify-content: center;
  padding-bottom: 8rem;
  max-height: 100%;
  overflow: auto;
  background: white;
  cursor: initial;
  @media #{$md-and-up} {
    max-height: none;
    max-width: 72rem;
    margin: 3rem 0;
  }
  @media #{$md-and-down} {
    height: 100%;
  }
  &__close {
    position: fixed;
    top: 2rem;
    right: 2rem;
    z-index: 50;
    width: 2rem;
    height: 2rem;
    > img {
      width: 100%;
      height: 100%;
    }
    @media #{$md-and-up} {
      position: absolute;
      cursor: pointer;
    }
  }
  &__images {
    position: relative;
    height: 32rem;
    padding: 5rem 2rem 0;
    @media #{$md-and-up} {
      height: 40rem;
      padding: 5rem 10rem 0;
      text-align: center;
    }
    &.--noslider {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-height: 100%;
      }
    }

    // SLIDER
    img {
      display: block;
      margin: auto;
      max-height: 20rem;
      max-width: 100%;
      @media #{$md-and-up} {
        max-height: 30rem;
      }
    }

    .agile__actions {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
  &__content {
    padding: 3rem;
    min-width: 100%;
  }
  &__intro {
    text-align: center;
    margin-bottom: 2rem;
    &__title {
      font-size: 2.4rem;
      font-weight: bold;
      margin-bottom: 1rem;
    }
    &__subtitle {
      color: get($colors, "grey");
      margin-bottom: 1rem;
    }
    &__size {
      > span {
        color: get($theme, "primary");
      }
    }
  }
  &__infos {
    margin-bottom: 2rem;
    &__item {
      display: flex;
      justify-content: space-between;
      padding: 1rem;
      font-size: 1.2rem;
      text-transform: uppercase;
      color: get($colors, "grey");
      border: 1px solid get($theme, "border");
      @media #{$md-and-down} {
        flex-direction: column;
        align-items: center;
      }
      > div:first-child {
        font-weight: bold;
      }
    }
  }
  &__btn {
    position: fixed;
    bottom: 3rem;
    left: 50%;
    width: 25rem;
    transform: translateX(-50%);
    box-shadow: get($shadows, "light");
    font-size: 1.6rem;
    @media #{$md-and-up} {
      position: absolute;
      bottom: 3rem;
    }
  }
}
</style>
